export { default } from './BulletPoints';
